export const getParams = (name: string) => {
    const results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        window.location.href
    );
    if (results == null) {
        return "";
    }
    return decodeURI(results[1]) || "";
};
